"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionItemWrap = exports.SelectPopupContainer = exports.FilterInputWrap = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.FilterInputWrap = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  height: 40px;
  background: var(--lowestBg);
  
  ${(props) => (0, styled_components_1.css) `
        cursor: ${props.pointer ? 'pointer' : 'default'};
      `}
  .widgetFilterTextInput {
    background: var(--lowestBg);
  }
`;
exports.SelectPopupContainer = styled_components_1.default.div `
  background: var(--highestBg);
  border-radius: 4px;
  box-shadow: var(--shadowCommonHighest);
  cursor: pointer;
  &:focus {
    outline: none;
  }
`;
exports.OptionItemWrap = styled_components_1.default.div `
  display: flex;
  align-items: center;
  padding: 0 8px;
  height: 32px;
  line-height: 32px;

  @media (any-hover: hover) {
    &:hover {
      background: var(--rowSelectedBg);
    } 
  }
`;
